export default __webpack_public_path__ + "static/media/Agrandir-Regular.aaa03f61.ttf";